import {RECIPIENT_MESSAGE_MAX, TrackTraceBranding, TrackTraceLanguage, trackTraceLanguages} from '../types/trackTrace.js'

type ResellerLike = {
    _id?: unknown
    settings?: {
        logo?: string
        color?: string
        accountName?: string
        companyAddress?: {name?: string, street?: string, nr?: string, addition?: string, postalCode?: string, city?: string}
        orders?: {trackTrace?: Record<string, unknown>}
        customers?: {welcomeEmailPhoto?: string}
        users?: {welcomeEmailPhoto?: string}
    }
}

const str = (value: unknown) => typeof value === 'string' ? value : ''

/** Url of the reseller's photo at the top of a welcome mail, or '' without a photo. */
export function welcomeMailPhoto(reseller: ResellerLike, kind: 'welcomeCustomer' | 'welcomeUser'): string {
    const id = str(kind === 'welcomeCustomer' ? reseller.settings?.customers?.welcomeEmailPhoto : reseller.settings?.users?.welcomeEmailPhoto)
    return id ? `/photo/reseller/${reseller._id}/${kind}?v=${id}` : ''
}

/** Branding of the Track & Trace page from the reseller settings. Shared by the server and the settings preview. */
export function trackTraceBranding(reseller: ResellerLike): TrackTraceBranding {
    const resellerSettings = reseller.settings || {}
    const settings = resellerSettings.orders?.trackTrace || {}
    const companyAddress = resellerSettings.companyAddress
    const languages = (Array.isArray(settings.languages) ? settings.languages : []).filter((language) => trackTraceLanguages.includes(language))
    const defaultLanguage = trackTraceLanguages.includes(settings.defaultLanguage as TrackTraceLanguage) ? settings.defaultLanguage as TrackTraceLanguage : 'nl'
    const faq = Array.isArray(settings.faq) ? settings.faq as {question?: unknown, answer?: unknown}[] : []
    const icon = settings.outForDeliveryStatusIcon

    return {
        resellerName: companyAddress?.name || resellerSettings.accountName || '',
        logoUrl: resellerSettings.logo ? `/logo/reseller/${reseller._id}` : null,
        color: resellerSettings.color || '#1F2D3D',
        outForDeliveryIcon: icon === 'bike' || icon === 'cargo-bike' ? icon : 'car',
        phone: str(settings.phone),
        email: str(settings.email),
        whatsapp: str(settings.whatsapp),
        footerTitle: str(settings.footerTitle),
        footerMessage: str(settings.footerMessage),
        companyAddress: settings.hideAddress || !companyAddress ?
            null :
            {
                name: companyAddress.name || '',
                street: companyAddress.street || '',
                nr: companyAddress.nr || '',
                addition: companyAddress.addition || '',
                postalCode: companyAddress.postalCode || '',
                city: companyAddress.city || ''
            },
        faq: settings.showFaq ? faq.filter((item) => str(item?.question)).map((item) => ({question: str(item.question), answer: str(item.answer)})) : [],
        languages: languages.length ? languages : [...trackTraceLanguages],
        defaultLanguage,
        // The file id in the url makes the browser load a new photo right away
        photo: settings.showPhoto ?
            {
                desktop: str(settings.photoDesktop) ? `/photo/reseller/${reseller._id}/desktop?v=${str(settings.photoDesktop)}` : null,
                mobile: str(settings.photoMobile) ? `/photo/reseller/${reseller._id}/mobile?v=${str(settings.photoMobile)}` : null
            } :
            null,
        message: settings.showRecipientMessage && str(settings.recipientMessage).trim() ? str(settings.recipientMessage).trim().slice(0, RECIPIENT_MESSAGE_MAX) : null
    }
}
